var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextAreaInput',{attrs:{"maxlength":"25","value":_vm.nameValue,"showTitle":false,"placeholder":"عنوان متن ثابت را اینجا وارد نمائید","required":""},on:{"input":function($event){return _vm.emitInputValut($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }